export const getRenderTypeWithDefault = (renderType: string, defaultValue: string): string => {
  return ['editorial', 'dynamic', 'fte'].includes(renderType) ? renderType : defaultValue;
};
